
import Vue from 'vue'
import { k2c } from '@/utils/helper'

interface IData {
  default: any
  invalid: boolean
  messages: any
  selected: string
}

const component = Vue.extend({
  data(): IData {
    return {
      default: {
        width: '100%',
        maxWidth: 320,
        persistent: true
      },
      invalid: false,
      messages: {
        default: this.App.data.message,
        invalid: '変更内容が保存されていません。ページを移動しますか？'
      },
      selected: 'default'
    }
  },
  computed: {
    __attrs(): any {
      // ケバブケースをキャメルケースに変換
      const $attrs: any = {}
      for (const key in this.$attrs) {
        $attrs[k2c(key)] = this.$attrs[key]
      }

      return {
        ...this.default,
        ...$attrs
      }
    },
    __message(): string {
      return this.messages[this.selected]
    }
  },
  watch: {
    'App.data.dialog': {
      async handler(value: boolean) {
        if (value) {
          this.invalid = await this.App.state.observer?.validate()
          this.selected = this.invalid ? 'default' : 'invalid'
        }
      }
    },
    'App.data.saving': {
      handler(value: boolean) {
        if (value === false && this.App.data.saved) {
          this.App.data.dialog = false
          this.App.data.clone = null
          this.App.data.saved = false
          this.$router.push(this.App.data.to.fullPath)
        }
      }
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
      this.App.data.saved = true
    },
    cancel() {
      this.$emit('cancel')
      this.App.data.dialog = false
      this.App.data.to = null
    },
    discard() {
      this.$emit('discard')
      this.App.data.dialog = false
      this.App.data.clone = null
      this.$router.push(this.App.data.to.fullPath)
    }
  }
})

Vue.component('AChangeDialog', component)
export default component
